import React from 'react';
import Translation from '../Translation';
const filter = (value, dataColumn) => {
    let range;
    let dataValue = parseFloat(dataColumn);
    if (!isNaN(dataValue)) {
        if (value.includes('-')) {
            range = value.split('-');
            if (!isNaN(range[0]) && !isNaN(range[1])) {
                return dataValue >= parseFloat(range[0]) && dataValue <= parseFloat(range[1]);
            }
        } else if (value.indexOf('>=') === 0) {
            range = value.split('>=')[1];
            if (!isNaN(range)) {
                return dataValue >= parseFloat(range);
            }

        } else if (value.indexOf('<=') === 0) {
            range = value.split('<=')[1];
            if (!isNaN(range)) {
                return dataValue <= parseFloat(range);
            }

        } else if (value.indexOf('>') === 0) {
            range = value.split('>')[1];
            if (!isNaN(range)) {
                return dataValue > parseFloat(range);
            }
        } else if (value.indexOf('<') === 0) {
            const range = value.split('<')[1];
            if (!isNaN(range)) {
                return dataValue < parseFloat(range);
            }
        } else if (value.indexOf('=') === 0) {
            const range = value.split('=')[1];
            if (!isNaN(range)) {
                return dataValue === parseFloat(range);
            }
        }
    }

    return dataColumn.toString().toLowerCase().includes(value.toLowerCase())
}

const statusRenderer = (status, d) => {
    return <span className={d.status === false ? 'text-danger-tag' : ''}>
        {d.status === false ? 'Inactive' : 'Active'}
    </span>;
}

const duplicateRenderer = (duplicate, d) => {
    return <span className={d.duplicate === true ? 'text-danger-tag' : ''}>
        {d.duplicate === true ? 'True' : 'False'}
    </span>;
}

const companyRenderer = (companyFlag, d) => {
    return <span className={d.companyflag === true ? 'text-danger-tag' : ''}>
        {d.companyflag === true ? 'True' : 'False'}
    </span>;
}
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}

let tableHeader = [
    {
        title: <Translation labelName="tbl_hdr_lot" defaultText="Lot" />,
        dataIndex: 'lot',
        key: 'lot',
        sorter: (a, b) => stringSort(a['lot'], b['lot']),
        onFilter: (value, record) => filter(value, record.lot)
    },
    {
        title: <Translation labelName="tbl_hdr_item" defaultText="Item" />,
        dataIndex: 'item',
        key: 'item',
        sorter: (a, b) => stringSort(a['item'], b['item']),
        onFilter: (value, record) => filter(value, record.item)
    },
    {
        title: <Translation labelName="manage_tow_Items_tbl_hdr_status" defaultText="Status" />,
        dataIndex: 'status',
        key: 'status',
        nocustomfilter: true,
        filters: [
            {
                text: 'Active',
                value: true,
            },
            {
                text: 'Inactive',
                value: false,
            }
        ],
        onFilter: (value, record) => {
            return record.status.toString() === value;
        },
        sorter: (a, b) => {
            return a.status - b.status;
        },
        render: (d, status) => {
            return statusRenderer(d, status)
        }
    },
    {
        title: <Translation labelName="lbl_plant" defaultText="Plant" />,
        dataIndex: 'plantcode',
        key: 'plantcode',
        nocustomfilter: true,
        filters: [
            {
                text: 'Celco',
                value: 'Celco',
            },
            {
                text: 'Lanaken',
                value: 'Lanaken',
            },
            {
                text: 'Ocotlan',
                value: 'Ocotlan',
            },
            {
                text: 'Spondon',
                value: 'Spondon',
            }
        ],
        sorter: (a, b) => stringSort(a['plantcode'], b['plantcode']),
        onFilter: (value, record) => {
            return (record.plantcode === value)
        }
    },
    {
        title: <Translation labelName="manage_tow_Items_tbl_hdr_duplicate" defaultText="Duplicate" />,
        dataIndex: 'duplicate',
        key: 'duplicate',
        nocustomfilter: true,
        filters: [
            {
                text: 'True',
                value: true,
            },
            {
                text: 'False',
                value: false,
            }
        ],
        onFilter: (value, record) => {
            if (typeof record.duplicate === 'undefined') {
                record.duplicate = false;
            }
            return record.duplicate.toString() === value;
        },
        sorter: (a, b) => {
            return a.duplicate - b.duplicate;
        },
        render: (d, duplicate) => {
            return duplicateRenderer(d, duplicate)
        }
    },
    {
        title: <Translation labelName="tbl_hdr_company_flag" defaultText="Chinese" />,
        dataIndex: 'companyflag',
        key: 'companyflag',
        nocustomfilter: true,
        filters: [
            {
                text: 'True',
                value: true,
            },
            {
                text: 'False',
                value: false,
            }
        ],
        onFilter: (value, record) => {
            if (typeof record.companyflag === 'undefined') {
                record.companyflag = false;
            }
            return record.companyflag.toString() === value;
        },
        sorter: (a, b) => {
            return a.companyflag - b.companyflag;
        },
        render: (companyflag, record) => {
            return companyRenderer(companyflag, record)
        }
    },
    {
        title: <Translation labelName="lbl_dpf" defaultText="DPF" />,
        children: [
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_nominal" defaultText="Nominal" />,
                dataIndex: 'nompf',
                key: 'nompf',
                sorter: (a, b) => {
                    return a.nompf - b.nompf;
                },
                onFilter: (value, record) => filter(value, record.nompf)
            },
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_actual" defaultText="Actual" />,
                dataIndex: 'lotadpf',
                key: 'lotadpf',
                sorter: (a, b) => {
                    return a.lotadpf - b.lotadpf;
                },
                onFilter: (value, record) => filter(value, record.lotadpf)
            }
        ]
    },
    {
        title: <Translation labelName="lbl_td" defaultText="TD" />,
        children: [
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_nominal" defaultText="Nominal" />,
                dataIndex: 'nomtd',
                key: 'nomtd',
                sorter: (a, b) => {
                    return a.nomtd - b.nomtd;
                },
                onFilter: (value, record) => filter(value, record.nomtd)
            },
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_actual" defaultText="Actual" />,
                dataIndex: 'lotatd',
                key: 'lotatd',
                sorter: (a, b) => {
                    return a.lotatd - b.lotatd;
                },
                onFilter: (value, record) => filter(value, record.lotatd)
            }
        ]
    },
    {
        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight" />,
        children: [
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_min" defaultText="Min" />,
                dataIndex: 'minwt',
                key: 'minwt',
                sorter: (a, b) => {
                    return a.minwt - b.minwt;
                },
                onFilter: (value, record) => filter(value, record.minwt)
            },
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_max" defaultText="Max" />,
                dataIndex: 'maxwt',
                key: 'maxwt',
                sorter: (a, b) => {
                    return a.maxwt - b.maxwt;
                },
                onFilter: (value, record) => filter(value, record.maxwt)
            }
        ]
    },
    {
        title: <Translation labelName="lbl_pressure_drop " defaultText="Pressure Drop" />,
        children: [
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_min" defaultText="Min" />,
                dataIndex: 'minpd',
                key: 'minpd',
                sorter: (a, b) => {
                    return a.minpd - b.minpd;
                },
                onFilter: (value, record) => filter(value, record.minpd)
            },
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_max" defaultText="Max" />,
                dataIndex: 'maxpd',
                key: 'maxpd',
                sorter: (a, b) => {
                    return a.maxpd - b.maxpd;
                },
                onFilter: (value, record) => filter(value, record.maxpd)
            }
        ]
    },
    {
        title: <Translation labelName="tbl_hdr_standard" defaultText="Standard" />,
        children: [
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_standard_width" defaultText="Width" />,
                dataIndex: 'stdpwth',
                key: 'stdpwth',
                sorter: (a, b) => {
                    return a.stdpwth - b.stdpwth;
                },
                onFilter: (value, record) => filter(value, record.stdpwth)
            },
            {
                title: <Translation labelName="lbl_length" defaultText="Length" />,
                dataIndex: 'stdlen',
                key: 'stdlen',
                sorter: (a, b) => {
                    return a.stdlen - b.stdlen;
                },
                onFilter: (value, record) => filter(value, record.stdlen)
            },
            {
                title: <Translation labelName="manage_tow_Items_tbl_sub_hdr_Standard_circle" defaultText="Circ." />,
                dataIndex: 'itmcirc',
                key: 'itmcirc',
                sorter: (a, b) => {
                    return a.itmcirc - b.itmcirc;
                },
                onFilter: (value, record) => filter(value, record.itmcirc)
            }
        ]
    },
];

export default tableHeader;


// WEBPACK FOOTER //
// ./src/model/TowItemSelectionTableHeader.js